module.exports = __webpack_public_path__ + "static/media/Multi_Cap.05605ca1.svg";